'use strict';

var Home = function() {
}

module.exports = Home;
